export const fadeUpVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] }
  }
};

export const staggerContainer = {
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};

export const buttonTap = {
  scale: 0.98,
  transition: { duration: 0.1 }
};

export const pulseDot = {
  scale: [1, 1.2, 1],
  opacity: [0.7, 1, 0.7],
  transition: { 
    repeat: Infinity, 
    duration: 2, 
    ease: "easeInOut" 
  }
};


